export const LEAGUE_LIST_REQUEST = 'LEAGUE_LIST_REQUEST'
export const LEAGUE_LIST_SUCCESS = 'LEAGUE_LIST_SUCCESS'
export const LEAGUE_LIST_FAIL    = 'LEAGUE_LIST_FAIL'

export const LEAGUE_DETAILS_REQUEST = 'LEAGUE_DETAILS_REQUEST'
export const LEAGUE_DETAILS_SUCCESS = 'LEAGUE_DETAILS_SUCCESS'
export const LEAGUE_DETAILS_FAIL    = 'LEAGUE_DETAILS_FAIL'

export const LEAGUE_ACTIVE_REQUEST = 'LEAGUE_ACTIVE_REQUEST'
export const LEAGUE_ACTIVE_SUCCESS = 'LEAGUE_ACTIVE_SUCCESS'
export const LEAGUE_ACTIVE_FAIL    = 'LEAGUE_ACTIVE_FAIL'

export const LEAGUE_CREATE_REQUEST = 'LEAGUE_CREATE_REQUEST'
export const LEAGUE_CREATE_SUCCESS = 'LEAGUE_CREATE_SUCCESS'
export const LEAGUE_CREATE_FAIL    = 'LEAGUE_CREATE_FAIL'
export const LEAGUE_CREATE_RESET   = 'LEAGUE_CREATE_RESET'

export const LEAGUE_UPDATE_REQUEST = 'LEAGUE_UPDATE_REQUEST'
export const LEAGUE_UPDATE_SUCCESS = 'LEAGUE_UPDATE_SUCCESS'
export const LEAGUE_UPDATE_FAIL    = 'LEAGUE_UPDATE_FAIL'
export const LEAGUE_UPDATE_RESET   = 'LEAGUE_UPDATE_RESET'

export const LEAGUE_DELETE_REQUEST = 'LEAGUE_DELETE_REQUEST'
export const LEAGUE_DELETE_SUCCESS = 'LEAGUE_DELETE_SUCCESS'
export const LEAGUE_DELETE_FAIL    = 'LEAGUE_DELETE_FAIL'

export const LEAGUE_REGISTER_PLAYER_REQUEST = 'LEAGUE_REGISTER_PLAYER_REQUEST'
export const LEAGUE_REGISTER_PLAYER_SUCCESS = 'LEAGUE_REGISTER_PLAYER_SUCCESS'
export const LEAGUE_REGISTER_PLAYER_FAIL    = 'LEAGUE_REGISTER_PLAYER_FAIL'

export const LEAGUE_REMOVE_PLAYER_REQUEST = 'LEAGUE_REMOVE_PLAYER_REQUEST'
export const LEAGUE_REMOVE_PLAYER_SUCCESS = 'LEAGUE_REMOVE_PLAYER_SUCCESS'
export const LEAGUE_REMOVE_PLAYER_FAIL    = 'LEAGUE_REMOVE_PLAYER_FAIL'

export const LEAGUE_GENERATE_SCHEDULE_REQUEST = 'LEAGUE_GENERATE_SCHEDULE_REQUEST'
export const LEAGUE_GENERATE_SCHEDULE_SUCCESS = 'LEAGUE_GENERATE_SCHEDULE_SUCCESS'
export const LEAGUE_GENERATE_SCHEDULE_FAIL    = 'LEAGUE_GENERATE_SCHEDULE_FAIL'

export const LEAGUE_MATCHUP_UPDATE_REQUEST = 'LEAGUE_MATCHUP_UPDATE_REQUEST'
export const LEAGUE_MATCHUP_UPDATE_SUCCESS = 'LEAGUE_MATCHUP_UPDATE_SUCCESS'
export const LEAGUE_MATCHUP_UPDATE_FAIL    = 'LEAGUE_MATCHUP_UPDATE_FAIL'

export const LEAGUE_MATCHUP_LOCK_REQUEST = 'LEAGUE_MATCHUP_LOCK_REQUEST'
export const LEAGUE_MATCHUP_LOCK_SUCCESS = 'LEAGUE_MATCHUP_LOCK_SUCCESS'
export const LEAGUE_MATCHUP_LOCK_FAIL    = 'LEAGUE_MATCHUP_LOCK_FAIL'

export const LEAGUE_SCORES_REQUEST = 'LEAGUE_SCORES_REQUEST'
export const LEAGUE_SCORES_SUCCESS = 'LEAGUE_SCORES_SUCCESS'
export const LEAGUE_SCORES_FAIL    = 'LEAGUE_SCORES_FAIL'

export const LEAGUE_SAVE_SCORE_REQUEST = 'LEAGUE_SAVE_SCORE_REQUEST'
export const LEAGUE_SAVE_SCORE_SUCCESS = 'LEAGUE_SAVE_SCORE_SUCCESS'
export const LEAGUE_SAVE_SCORE_FAIL    = 'LEAGUE_SAVE_SCORE_FAIL'
